import { Box, Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import AppContext from '../../app/context'
import { MOBILE_WIDTH_HIGH } from '../../constants/constants'
import { useWindowSize } from '../../hooks/useWindowSize'
import buildStyles from './styles'

export interface HeaderInfoProps {
  title: string
  arrowedTitle: string
  orgName?: string
  altText?: string
  addedPadding?: boolean
  addedSmallPadding?: boolean
}

const HeaderInfo = ({
  title,
  arrowedTitle,
  orgName,
  altText,
  addedPadding,
  addedSmallPadding,
}: HeaderInfoProps) => {
  const { state } = useContext(AppContext)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    isMobile: isMobile,
    baseColors: state.locationDesignConfig?.baseColors,
  })

  const getPadding = () => {
    if (addedSmallPadding) return '46px'
    else if (addedPadding) return '236px'
    else return undefined
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={styles.wrapper}
    >
      <Grid item container direction="column" alignItems="center">
        <Grid
          item
          className={styles.title}
          style={{
            paddingLeft: getPadding(),
            paddingRight: getPadding(),
          }}
        >
          {title}
        </Grid>
        <Grid item className={styles.arrowedTitle}>
          <Box
            display="flex"
            width="100%"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
          >
            <div className={styles.bluebar} style={{ marginRight: '8px' }} />
            <div>{arrowedTitle}</div>
            <div
              className={styles.bluebar}
              style={{ marginLeft: '8px', transform: 'rotate(-180deg)' }}
            />
          </Box>
        </Grid>
        {orgName && (
          <Grid item className={styles.orgName}>
            {orgName}
          </Grid>
        )}
        {altText && (
          <Grid item className={styles.altText}>
            {altText}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default HeaderInfo
